const personalQuizUrl = ({ quizId = null }: { quizId?: number } = {}) =>
  `/quizzes/${quizId ?? ''}`;

const baseURL = `${window.APP_CONFIG.TEACHER_SERVICE}`;

export { personalQuizUrl, baseURL };
